<template>
  <el-dialog
    :title="$t('chainSupplierCatalog.addCatalog')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form :model="addChainSupplierCatalogInfo" :rules="rules" ref="form" label-width="150px">
      <el-form-item :label="$t('chainSupplierCatalog.catalogName')" prop="catalogName">
        <el-input v-model="addChainSupplierCatalogInfo.catalogName" :placeholder="$t('chainSupplierCatalog.catalogNamePlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplierCatalog.intfUrlParam')" prop="intfUrlParam">
        <el-input v-model="addChainSupplierCatalogInfo.intfUrlParam" :placeholder="$t('chainSupplierCatalog.intfUrlParamPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('chainSupplierCatalog.seq')" prop="seq">
        <el-input v-model="addChainSupplierCatalogInfo.seq" :placeholder="$t('chainSupplierCatalog.seqPlaceholder')"></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="saveChainSupplierCatalogInfo">{{$t('common.save')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveChainSupplierCatalog } from '@/api/admin/chainSupplierCatalog/chainSupplierCatalogApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddChainSupplierCatalog',
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    return {
      dialogVisible: false,
      addChainSupplierCatalogInfo: {
        catalogId: '',
        catalogName: '',
        csId: '',
        intfUrlParam: '',
        seq: '',
        statusCd: '0',
        shopId: ''
      },
      rules: {
        catalogName: [
          { required: true, message: this.$t('chainSupplierCatalog.catalogNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('chainSupplierCatalog.catalogNameMaxLength'), trigger: 'blur' }
        ],
        csId: [
          { required: true, message: this.$t('chainSupplierCatalog.supplierIdRequired'), trigger: 'blur' },
          { max: 32, message: this.$t('chainSupplierCatalog.supplierIdMaxLength'), trigger: 'blur' }
        ],
        intfUrlParam: [
          { required: true, message: this.$t('chainSupplierCatalog.intfUrlParamRequired'), trigger: 'blur' },
          { max: 64, message: this.$t('chainSupplierCatalog.intfUrlParamMaxLength'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('chainSupplierCatalog.seqRequired'), trigger: 'blur' },
          { max: 10, message: this.$t('chainSupplierCatalog.seqMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.resetForm()
      this.addChainSupplierCatalogInfo.csId = params.csId
      this.addChainSupplierCatalogInfo.shopId = getShopId()
    },
    resetForm() {
      this.addChainSupplierCatalogInfo = {
        catalogId: '',
        catalogName: '',
        csId: '',
        intfUrlParam: '',
        seq: '',
        statusCd: '0',
        shopId: ''
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    saveChainSupplierCatalogInfo() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        
        if (this.callBackListener) {
          this.$emit(this.callBackListener, this.callBackFunction, this.addChainSupplierCatalogInfo)
          this.dialogVisible = false
          return
        }

        saveChainSupplierCatalog(this.addChainSupplierCatalogInfo).then(response => {
          const res = response.data
          if (res.code === 0) {
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('listChainSupplierCatalog')
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          this.$message.error(error.message)
        })
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 100%;
}
</style>